import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { FaWhatsapp } from 'react-icons/fa';
import { getSettings } from '../../services/api';

const Button = styled.a`
  position: fixed;
  bottom: 24px;
  left: 24px;
  width: 56px;
  height: 56px;
  border-radius: 50%;
  background: #25D366;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
  z-index: 999;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.08);
    color: white;
  }

  @media (max-width: 768px) {
    width: 48px;
    height: 48px;
    font-size: 1.6rem;
    bottom: 16px;
    left: 16px;
  }
`;

const WhatsAppButton: React.FC = () => {
  const [number, setNumber] = useState('');

  useEffect(() => {
    getSettings()
      .then(res => setNumber(res.data.whatsapp_number || ''))
      .catch(() => {});
  }, []);

  const digits = number.replace(/\D/g, '');
  if (!digits) return null;

  return (
    <Button
      href={`https://wa.me/${digits}`}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="تواصل عبر واتساب"
    >
      <FaWhatsapp />
    </Button>
  );
};

export default WhatsAppButton;
